import { QueryClient } from '@tanstack/react-query'
import { isApiError } from './api'

/** Retry only network failures and 5xx responses, at most twice. 4xx answers are final. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false
  if (isApiError(error)) return error.status === 0 || error.status >= 500
  // Non ApiError (a bug in a queryFn, an aborted request): do not hammer.
  return false
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: shouldRetry,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: false,
      },
    },
  })
}

export const queryClient = createQueryClient()
